"use client";

import { memo } from "react";
import { HeroDark } from "@/components/screen/global-components/hero";

const FAQHero = ({
}: React.ComponentProps<"section">) => {
  return <HeroDark title="Languex help center and FAQs" description="Explore the answers to frequently asked questions, helpful articles and guides to help you get the most out of Languex’s services." descriptionClassName="lg:max-w-[585] lg:mx-auto" />;
};

export default memo(FAQHero);
